module.exports = __webpack_public_path__ + "media/6zl.3f2db1a7.mp3";